// import p2 from 'p2';

export const PhysicsCollisionGroup = {
    VEHICLE: 2,
    GROUND: 4,
    OBJECT: 8,
    SPECIAL: 16,
    LEVEL: 4 | 8 | 16,
};

// export const PhysicsMaterial = {
//     ground: new p2.Material(),
//     slime: new p2.Material(),
//     chassis: new p2.Material(),
//     wheels: new p2.Material(),
//     conveyerLeft: new p2.Material(),
//     conveyerRight: new p2.Material(),
// };

// export interface PhysicsContactsDescription extends p2.ContactMaterialOptions
// {
//     mainMaterial: keyof (typeof PhysicsMaterial),
//     otherMaterials: (keyof (typeof PhysicsMaterial)| 'default')[]
// }

// export const PhysicsContacts: PhysicsContactsDescription[] = [
//     {
//         mainMaterial: 'wheels',
//         otherMaterials: ['ground'],
//         friction: 4,
//     },
//     {
//         mainMaterial: 'wheels',
//         otherMaterials: ['slime'],
//         friction: 0.7,
//     },
//     {
//         mainMaterial: 'conveyerLeft',
//         otherMaterials: ['wheels', 'chassis', 'default'],
//         friction: 4,
//         surfaceVelocity: 800,
//     },
//     {
//         mainMaterial: 'conveyerRight',
//         otherMaterials: ['wheels', 'chassis', 'default'],
//         friction: 4,
//         surfaceVelocity: -800,
//     },
// ];
